module.exports = __webpack_public_path__ + "fonts/IBMPlexSans.2526ba23.ttf";